// extracted by mini-css-extract-plugin
export default {"emptyStateDivBox":"emptyStateDivBox__DZ5on","tessieListBody":"tessieListBody__xxlP3"};